module.exports = __webpack_public_path__ + "static/media/Knight246_2c.ebb450db.svg";